import Vue from 'vue';
import Antd from 'ant-design-vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

import App from './App.vue';
import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false;

Vue.use(Antd);

require('moment/locale/de');

Vue.use(VueMoment, {
  moment,
});
console.log(Vue.moment().locale());

new Vue({
  render: h => h(App),
}).$mount('#app');
